export default __webpack_public_path__ + "static/media/logo.fffa7dd6.png";